export const environment = {
  production: true,
  firebaseConfig : {
    apiKey: "AIzaSyAxfD5lGfcjfxI_gv-SvjXmFNstgDFEzp4",
    authDomain: "angularchat-d86c6.firebaseapp.com",
    databaseURL: "https://angularchat-d86c6-default-rtdb.firebaseio.com",
    projectId: "angularchat-d86c6",
    storageBucket: "angularchat-d86c6.appspot.com",
    messagingSenderId: "943806393480",
  },
  authApiUrl: 'https://tech-blog-backend.herokuapp.com/authenticate',
  userApiUrl: 'https://tech-blog-backend.herokuapp.com/user/',
  postsApiUrl: 'https://tech-blog-backend.herokuapp.com/posts/'
};
